import { Identifiable, List, Event } from "@planzone/dto";
import { events as e } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { resizeList } from "./utils/resizeList";
import { reduceEvent } from "../event";

function editEvents(
  list: Identifiable<List>,
  event: Boundaries["editEvent"]["success"],
) {
  return list.events.reduce<{
    hasMatch: boolean;
    events: Identifiable<Event>[];
  }>(
    ({ hasMatch, events }, t) => ({
      hasMatch: hasMatch || t.uuid === event.uuid,
      events: [
        ...events,
        reduceEvent(t, { type: e.editEventSucceeded, data: event }),
      ],
    }),
    { hasMatch: false, events: [] },
  );
}

function editSubLists(
  list: Identifiable<List>,
  event: Boundaries["editEvent"]["success"],
) {
  return list.subLists.reduce<{
    hasMatch: boolean;
    subLists: Identifiable<List>[];
  }>(
    ({ hasMatch, subLists }, subList) => {
      const { hasMatch: hasSubListMatch, list: nextSubList } = editList(
        subList,
        event,
      );

      return {
        hasMatch: hasMatch || hasSubListMatch,
        subLists: [...subLists, nextSubList],
      };
    },
    { hasMatch: false, subLists: [] },
  );
}

function editList(
  list: Identifiable<List>,
  event: Boundaries["editEvent"]["success"],
): { hasMatch: boolean; list: Identifiable<List> } {
  const { hasMatch, events } = editEvents(list, event);
  const { hasMatch: hasSubListMatch, subLists } = editSubLists(list, event);
  const nextList = { ...list, events, subLists };
  const isMatching = hasMatch || hasSubListMatch;

  return {
    hasMatch: isMatching,
    list: isMatching ? resizeList(nextList, event.endTime) : nextList,
  };
}

function handleEditEvent(
  list: Identifiable<List>,
  event: Boundaries["editEvent"]["success"],
): Identifiable<List> {
  return editList(list, event).list;
}

export { handleEditEvent };
